function* range(start, end, step = 1) {
    if (end === undefined)
        return yield* range(0, start);
    if (step < 0) {
        while (start > end) {
            yield start;
            start += step;
        }
    }
    else {
        while (start < end) {
            yield start;
            start += step;
        }
    }
}
export default range;
//# sourceMappingURL=range.js.map